import { render } from "./02-MainInfoDisplay.vue?vue&type=template&id=c955d7a4"
import script from "./02-MainInfoDisplay.vue?vue&type=script&lang=js"
export * from "./02-MainInfoDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/home/randreu/projects/gringo/UPlanner/QRAsistencia/apps/qr-asistencia/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__